// @flow
import { setPartialUpdateDefaultSettings }                  from 'fg-frontend/src/partialUpdate/PartialUpdateSettings';
import { partialUpdateConnectDatasetListeners }             from 'fg-frontend/src/partialUpdate/eventsFromDOMDatasetsRegister';
import partialUpdateConnectLinksListeners                   from 'fg-frontend/src/partialUpdate/connectLinksListeners';
import partialUpdateConnectFormsSubmitListeners             from 'fg-frontend/src/partialUpdate/connectFormsSubmitListeners';
import partialUpdateConnectHistory                          from 'fg-frontend/src/partialUpdate/connectHistory';
import { execute }                                          from 'fg-frontend/src/partialUpdate/partialUpdate';
import { onChangeXHRQueue as CursorSpinnerOnChangeHandler } from 'fg-frontend/src/components/CursorSpinner';

import 'fg-frontend/plugins/jquery.simple-collapse';

let $ = require('jquery');

// nastavení defaultních vlastností partial updatu
setPartialUpdateDefaultSettings({
  onChangeXHRQueue: CursorSpinnerOnChangeHandler,
  // využívá se pro manipulaci s historií
  // je potřeba mít na všech stránkách jsPartialUpdate s id,
  // kde je nastaveno <partialUpdateAlterHistory>true</partialUpdateAlterHistory>
  globalTarget: 'dynamicArea',
  suppressRedirect: true,
});

document.addEventListener('partialUpdateComplete', ({ detail: { settings, hasError, newAccessibleTarget } }) => {
  // const {
  //   type,
  //   url,
  // } = settings;

  // po jakémkoliv přihlášení přes partial update se zaktualizují widgety související s přihlášením
  // if (type === 'POST' && !hasError && url.startsWith(`/qf/${window.projectConfig.lang}/ramjet/performLogin`)) {
	//   const includeTargets = [
	// 	  'userMenu',
	// 	  'userLists',
	//   ].filter((targetId) => document.getElementById(targetId) != null);
	//   const locationTargets = [
	// 	  'partialUpdateContainer',
	//   ].filter((targetId) => document.getElementById(targetId) != null);
  //
	//   // include widgety
	//   if (includeTargets.length > 0) {
	// 	  execute({
	// 		  url: `/qf/${window.projectConfig.lang}/ramjet/include`,
	// 		  target: includeTargets,
	// 	  });
	//   }
	//   // PU obsah stranky
	//   if (locationTargets.length > 0) {
  //       execute({
  //           url: location.href,
  //           target: locationTargets,
  //       });
	//   }
  // }
});

partialUpdateConnectDatasetListeners(['slideStop']);
partialUpdateConnectFormsSubmitListeners();
partialUpdateConnectLinksListeners({
  alterHistory: true,
});
partialUpdateConnectHistory();



// WEBPACK FOOTER //
// ./fe/web-career/src/js/configurePartialUpdate.js